const steps = [
    {
      element: '#dashboard-filter',
      popover: {
        title: 'Filter Dashboard Data',
        description: 'Filter data of dashboard accortion to selction',
        position: 'bottom'
      }
    },
    {
      element: '#link-count-description',
      popover: {
        title: 'Link Hit',
        description: 'Show Total link payment',
        position: 'bottom'
      }
    },
    // {
    //   element: '#Transaction',
    //   popover: {
    //     title: 'Transaction Detail',
    //     description: 'Shows total transaction through link pay',
    //     position: 'left'
    //   }
    // },
    {
      element: '#transaction-page',
      popover: {
        title: 'Screenfull',
        description: 'Set the page into fullscreen',
        position: 'left'
      }
    },
    {
      element: '#size-select',
      popover: {
        title: 'Switch Size',
        description: 'Switch the system size',
        position: 'left'
      }
    },
    {
      element: '#tags-view-container',
      popover: {
        title: 'Tags view',
        description: 'The history of the page you visited',
        position: 'bottom'
      },
      padding: 0
    }
  ]
  
  export default steps
  